import Folder from './Folder/Routes';
import Letters from './Letters/Routes';
import Office from './Office/Routes';
import Task from './Task/Routes';

export default [...Folder, ...Letters, ...Office, ...Task];